import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { redirectToOnboarding, segmentTrack } from 'src/app/state/actions';
import type { Dispatch, RootState } from 'src/app/state/store';
import { getLocationParams } from 'src/app/utils/localeUtils';
import { arePathnamesEqual } from 'src/app/utils/stringUtils';

import { MultiReferralPromo } from './constants';

import { MemoizedUnconnectedPromotionalLandingPage } from '.';

const mapStateToProps = (state: RootState, ownProps: OwnPropsType) => {
  const { match } = ownProps;
  const promoCode = match.params.promo_code;
  const params = getLocationParams(state.router?.location?.search);
  const version = params['v'];
  const pathname = state.router.location.pathname;
  const isCCA = arePathnamesEqual(pathname, '/l/cca');

  //TODO: PAR-645 refactor consts to not be CCA specific
  return {
    promoCode,
    version,
    isCCA,
    isSinglePromoReferral: promoCode in MultiReferralPromo,
    promoReferral: params['referral'],
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  segmentTrack: (event: UnifiedEvent, payload: Record<string, unknown>) => dispatch(segmentTrack(event, payload)),
  onRedirectToOnboarding: (referral?: string) =>
    dispatch(redirectToOnboarding('Promo Landing Page Mobile CTA', { referral })),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export const PromotionalLandingPage = withRouter(connector(MemoizedUnconnectedPromotionalLandingPage));
